module.exports = __webpack_public_path__ + "static/media/valsa-partitura.65910cf8.png";